import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchAccessoriesRequests = (params = {}) => apiActionCreator({
  'endpoint': `/accessories/requests${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ACCESSORIES_REQUESTS,
    ActionTypes.FETCHED_ACCESSORIES_REQUESTS,
    [
      ActionTypes.FETCHED_ACCESSORIES_REQUESTS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateAccessoriesRequests = (data = {}, params) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/accessories/requests',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_ACCESSORIES_REQUESTS,
        [
          () => {
            if (params) {
              dispatch(fetchAccessoriesRequests(params));
            }
            return {
              'type': ActionTypes.UPDATED_ACCESSORIES_REQUESTS,
            };
          },
          (response) => MessageActions.addMessageBoxInfo(`Se ha generado el pedido ${response.code}`),
        ],
        [
          ActionTypes.UPDATED_ACCESSORIES_REQUESTS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],

      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      data,
    }),
  );
};

export const cleanAccessoriesRequestsList = () => ({
  'type': ActionTypes.CLEAN_ACCESSORIES_REQUESTS_LIST,
});

export const fetchAccessoriesRequestsSummary = (params = {}) => apiActionCreator({
  'endpoint': `/accessories/requests/summary${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ACCESSORIES_REQUESTS_SUMMARY,
    ActionTypes.FETCHED_ACCESSORIES_REQUESTS_SUMMARY,
    [
      ActionTypes.FETCHED_ACCESSORIES_REQUESTS_SUMMARY_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
